var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('header-bar'),_c('div',{staticClass:"row"},[(_vm.isLogin)?_c('div',{staticClass:"menu-sidebar"},[_c('menu-sidebar')],1):_vm._e(),_c('div',{staticClass:"content margin-top",class:{ 'login-background': _vm.$route.path == '/login' }},[_c('div',{staticClass:"container"},[_c('router-view')],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }